<template>
  <div class="index-content">
    <div class="headerBox">
      <div class="headerItem">
        <div>社区总人口</div>
        <div>64826</div>
      </div>
      <div class="headerItem">
        <div>常住人口</div>
        <div>61680</div>
      </div>
      <div class="headerItem">
        <div>流动人口</div>
        <div>64826</div>
      </div>
      <div class="headerItem">
        <div>党员</div>
        <div>3146</div>
      </div>
      <div class="headerItem">
        <div>残疾人</div>
        <div>665</div>
      </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
      <div class="headerItem">
        <div>高龄老人</div>
        <div>352</div>
      </div>
    </div>
    <div class="contentBox">
      <div class="contentItem">
        <div>事件上报</div>
        <div id="eventReport"></div>
      </div>
      <div class="contentItem">
        <div>事件上报分布</div>
        <div id="eventDistribute"></div>
      </div>
      <div class="contentItem">
        <div>在线智能硬件</div>
        <div class="hanwareBox">
          <div>
            <div class="subBox">
              <div class="subTitle">
                <img src="@/assets/images/home1.png" alt height="16" />
                <span>智能门禁</span>
              </div>
              <div class="subNum">12</div>
            </div>
            <div class="subBox">
              <div class="subTitle">
                <img src="@/assets/images/home2.png" alt height="16" />
                <span>智能垃圾箱</span>
              </div>
              <div class="subNum">20</div>
            </div>
            <div class="subBox">
              <div class="subTitle">
                <img src="@/assets/images/home3.png" alt height="16" />
                <span>智能摄像头</span>
              </div>
              <div class="subNum">18</div>
            </div>
          </div>
          <div>
            <div class="subBox">
              <div class="subTitle">
                <img src="@/assets/images/home4.png" alt height="16" />
                <span>车位监控</span>
              </div>
              <div class="subNum">16</div>
            </div>
            <div class="subBox">
              <div class="subTitle">
                <img src="@/assets/images/home5.png" alt height="16" />
                <span>智能井盖</span>
              </div>
              <div class="subNum">38</div>
            </div>
            <div class="subBox">
              <div class="subTitle">
                <img src="@/assets/images/home6.png" alt height="16" />
                <span>高龄安防设备</span>
              </div>
              <div class="subNum">298</div>
            </div>
          </div>
        </div>
      </div>
      <div class="contentItem">
        <div>居民签到</div>
        <div id="residentSign"></div>
      </div>
      <div class="contentItem">
        <div>智慧便民年龄分布</div>
        <div id="ageDistribute"></div>
      </div>
      <div class="contentItem">
        <div class="refreshTitle">
          <div>
            数据更新
            <i class="el-icon-refresh"></i>
          </div>
          <div>最近更新：2019.07.01 16:27</div>
        </div>
        <div class="refreshBox">
          <div>
            <div class="subBox">
              <div class="subTitle">民政</div>
              <el-Row>
                <el-col :span="12">累计</el-col>
                <el-col :span="12">23</el-col>
              </el-Row>
              <el-Row>
                <el-col :span="12">今日</el-col>
                <el-col :span="12">2</el-col>
              </el-Row>
            </div>
            <div class="subBox">
              <div class="subTitle">住房</div>
              <el-Row>
                <el-col :span="12">累计</el-col>
                <el-col :span="12">18</el-col>
              </el-Row>
              <el-Row>
                <el-col :span="12">今日</el-col>
                <el-col :span="12">1</el-col>
              </el-Row>
            </div>
            <div class="subBox">
              <div class="subTitle">党建</div>
              <el-Row>
                <el-col :span="12">累计</el-col>
                <el-col :span="12">6</el-col>
              </el-Row>
              <el-Row>
                <el-col :span="12">今日</el-col>
                <el-col :span="12">0</el-col>
              </el-Row>
            </div>
            <div class="subBox">
              <div class="subTitle">计生</div>
              <el-Row>
                <el-col :span="12">累计</el-col>
                <el-col :span="12">12</el-col>
              </el-Row>
              <el-Row>
                <el-col :span="12">今日</el-col>
                <el-col :span="12">1</el-col>
              </el-Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts';
export default {
  data() {
    return {};
  },
  mounted() {
    // 实例化echarts
    this.initEcharts();
  },
  methods: {
    initEcharts() {
      let eventReport = echarts.init(document.getElementById('eventReport'));
      let eventDistribute = echarts.init(
        document.getElementById('eventDistribute')
      );
      let residentSign = echarts.init(document.getElementById('residentSign'));
      let ageDistribute = echarts.init(
        document.getElementById('ageDistribute')
      );
      window.addEventListener('resize', () => {
        eventReport.resize();
        eventDistribute.resize();
        residentSign.resize();
        ageDistribute.resize();
      });
      //事件上报 实例化折线图
      this.initEventReport(eventReport);
      //事件上报分布 实例化饼状图
      this.initEventDistribute(eventDistribute);
      //居民签到  实例化柱状图
      this.initResidentSign(residentSign);
      //智慧便民年龄分布
      this.initAgeDistribute(ageDistribute);
    },
    initEventReport(echart) {
      echart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['上报事件', '解决事件']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '上报事件',
            type: 'line',
            stack: '总量',
            data: [120, 132, 101, 134, 90, 230, 210],
            smooth: true
          },
          {
            name: '解决事件',
            type: 'line',
            stack: '总量',
            data: [220, 182, 191, 234, 290, 330, 310],
            smooth: true
          }
        ]
      });
    },
    initEventDistribute(echart) {
      echart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          top: 'center',
          left: '5%',
          data: ['公共卫生', '投诉建议', '硬件设备', '紧急求助']
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: 335,
                name: '公共卫生',
                itemStyle: {
                  color: '#5FB878'
                }
              },
              {
                value: 310,
                name: '投诉建议',
                itemStyle: {
                  color: '#70BFF9'
                }
              },
              {
                value: 234,
                name: '硬件设备',
                itemStyle: {
                  color: '#FFB980'
                }
              },
              {
                value: 135,
                name: '紧急求助',
                itemStyle: {
                  color: '#009688'
                }
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
    initResidentSign(echart) {
      echart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['当面签到', '网络签到']
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '当面签到百分比',
            type: 'bar',
            itemStyle: {
              color: '#009688'
            },
            data: [80, 85, 86, 84, 83],
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            }
          },
          {
            name: '网络签到百分比',
            type: 'bar',
            itemStyle: {
              color: '#1E9FFF'
            },
            data: [95, 92, 94, 93, 96],
            markPoint: {
              data: [
                { name: '年最高', value: 182.2, xAxis: 7, yAxis: 183 },
                { name: '年最低', value: 2.3, xAxis: 11, yAxis: 3 }
              ]
            }
          }
        ]
      });
    },
    initAgeDistribute(echart) {
      echart.setOption({
        color: ['#009688'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '5%',
          right: '8%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['19岁以下', '20~29岁', '30~39岁', '40~49岁', '50岁及以上'],
            interval: 1,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            position: 'left',
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            name: '所占百分比',
            type: 'bar',
            barWidth: '60%',
            label: {
              normal: {
                show: true,
                position: 'top',
                formatter: '{c}%'
              }
            },
            data: [18, 21, 26, 20, 15]
          }
        ]
      });
    }
  }
};
</script>
<style lang='less' scoped>
@import url('./index.less');
</style>
<style lang='less'>
@import url('./ele-index.less');
</style>



